import { Component, Input } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { ViewComponentsDialogService } from './services/view-components-dialog.service'
import { DataAnalyticsClickSource, maxQuantityFallback, MbConstants } from '../../../shared/mb-constants'
import { ViewMultiValueDialogService } from './services/view-multi-value-dialog.service'
import { Config, TranslationService } from '@spartacus/core'
import { MbProductService } from '../../../shared/services/mb-product-service'
import { ProductLine } from '../../../models'
import { sortStamps } from '../../../shared/utils/stamps-utils'

@Component({
  selector: 'mb-product-line',
  templateUrl: './product-line.component.html',
  styleUrls: ['./product-line.component.scss']
})
export class ProductLineComponent {

  maxItemQuantity = +(this.config.context?.maxAllowedQuantityPerProductInCart || maxQuantityFallback)

  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  })
  stamps: string[] = []

  // TODO refactor this; this is actually a product (BUG)
  model: ProductLine | undefined

  @Input() dataAnalyticsClickSource: DataAnalyticsClickSource | undefined

  @Input() set productLine (value: ProductLine | undefined) {
    if (value) {
      this.model = value
      this.stamps = sortStamps(value?.stamps)
    }
  }

  get productLine () {
    return this.model
  }

  constants = MbConstants

  @Input() showDynamicColumns = false

  @Input() isWishListShown: boolean | undefined

  constructor (private viewComponentsDialogService: ViewComponentsDialogService,
              private viewMultiValueDialogService: ViewMultiValueDialogService,
              private translationService: TranslationService,
              private mbProductService: MbProductService,
              protected config: Config) { }

  open (components: any) {
    this.viewComponentsDialogService.open(components)
  }

  hasPriceOnRequest () {
    return this.model?.hasPriceOnRequest === true
  }

  openMultiValueModal (multiValueData: any,
                      modalTitle: string) {
    this.viewMultiValueDialogService.open(multiValueData, modalTitle)
  }

  addDataSheetUserManualLink (linkText: string,
                             type: string,
                             isCartPage: boolean) {
    return this.mbProductService.addDataSheetUserManualLink(linkText, type, isCartPage)
  }
}
